export default __webpack_public_path__ + "static/media/desert.ee871b9e.svg";